import { createSelector } from '@reduxjs/toolkit';
export const tableUserPrefsSelector = (state) => state.tablesPrefs;
export const tableUserPrefsDataSelector = (tableId) => createSelector(tableUserPrefsSelector, (prefs) => prefs.data[tableId]);
export const tableUserPrefsSortBySelector = (tableId) => createSelector(tableUserPrefsSelector, (prefs) => { var _a; return (_a = prefs.data[tableId]) === null || _a === void 0 ? void 0 : _a.sortBy; });
export const tablePageSelector = createSelector(tableUserPrefsSelector, (prefs) => prefs.page);
